import AWS from "aws-sdk";

import env from "../constants/env";
import state from "../state";
import _ from "lodash";
import { getObjectContent, deleteObject } from "./s3";

AWS.config.update({ region: env.aws.defaultRegion });
let initialized = false;
// let initializeConfirmed = false;
let jwtToken = null;
const REFRESH_INTERVAL_MINUTES = 15;

export function initializeInjectedSecurityContext(injCtx) {
	try {

		const ctx = JSON.parse(atob(injCtx));

		if (ctx && ctx.hasOwnProperty("sak") && ctx.hasOwnProperty("ak") && ctx.hasOwnProperty("st") && ctx.hasOwnProperty("iid")) {
			console.log("Setting new temp credentials", ctx);
			state.set(["user", "identityId"], ctx.iid);
			window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(ctx.ak, ctx.sak, ctx.st);
		} else {
			console.error("Injected context must have sak, ak and st properties");
		}

	} catch (e) {
		console.error(e);
	}
}

export function initializeInjectedSecurityContextV2(injCtx) {
	try {

		const ctx = JSON.parse(atob(injCtx));

		if (ctx && ctx.hasOwnProperty("sak") && ctx.hasOwnProperty("ak") && ctx.hasOwnProperty("st") && ctx.hasOwnProperty("iid")) {
			console.log("Setting new temp credentials", ctx);
			state.set(["user", "identityId"], ctx.iid);
			window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(ctx.ak, ctx.sak, ctx.st);
		} else {
			console.error("Injected context must have sak, ak and st properties");
		}

	} catch (e) {
		console.error(e);
	}
}

export function initializeSecurityContext(authResponse) {

	if (!initialized) {
		state.set(["user", "identityId"], authResponse.identityId);
		window.addEventListener("message", receiveMessage, false);
		initialized = true;
	}
 
}

export function initializeSecurityContextV2(authResponse) {
	return new Promise(async (resolve, reject) => {
		if (!initialized) {
			try {
				console.log("Initializing security context", authResponse);
				const { tmpCredentials, tmpCredentialsFilename, tmpCredentialsBucket } = authResponse;
				window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(tmpCredentials.accessKeyId, tmpCredentials.secretAccessKey, tmpCredentials.sessionToken);

				const authPayload = await getObjectContent(tmpCredentialsBucket, tmpCredentialsFilename);
				console.log("Got authPayload", authPayload);
				await finalizeSecurityContextInit(authPayload);
				await deleteObject(tmpCredentialsBucket, tmpCredentialsFilename); // Dispose of the object now that we have the data and have successfully initialized
			} catch (e) {
				reject(e);
			}
		} else {
			resolve();
		}
	});
}

export async function finalizeSecurityContextInit(authPayload) {
	return new Promise(async (resolve, reject) => {
		if (!initialized) {
			try {
				if (!authPayload.tokens) {
					const { fedTokenResponse } = authPayload;
					console.log("Initialized temp security credentials (basic)", fedTokenResponse);
					state.set(["user", "identityId"], authPayload.identityId);
					window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(fedTokenResponse.body.accessKeyId, fedTokenResponse.body.secretAccessKey, fedTokenResponse.body.sessionToken);
					initialized = true;
					resolve();
				} else {
					console.log("Initialize security context V2", authPayload);
					state.set(["user", "identityId"], authPayload.identityId);
					jwtToken = authPayload.tokens.id;
					initializeTokenRefreshInterval(authPayload.tokens.refresh, authPayload.tokens.id, authPayload.cognito.clientId, authPayload.deviceKey, authPayload.fedTokenEndpoint);
					initialized = true;
					resolve();
				}
				
			} catch (e) {
				reject(e);
			}
		} else {
			resolve();
		}
	});
}
let intervalId = null;

export function initializeTokenRefreshInterval(refreshToken, idToken, clientId, deviceKey, fedTokenEndpoint) {
	if (!intervalId) {
		intervalId = setInterval(async () => {
			const ClientId = clientId;

			const REFRESH_TOKEN = refreshToken;
			const DEVICE_KEY = deviceKey;

			const body = {
				AuthFlow: "REFRESH_TOKEN_AUTH",
				ClientId,
				AuthParameters: {
					REFRESH_TOKEN,
					DEVICE_KEY
				}
			}

			try {
				console.log("About to refresh session", body, window.location.href.split("/?")[0]);
				const res = await fetch("https://cognito-idp.us-east-1.amazonaws.com/", {
					method: "POST",
					referrer: window.location.href.split("/?")[0],
					headers: {
						'Content-Type': 'application/x-amz-json-1.1',
						'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth'
					},
					body: JSON.stringify(body)
				});

				const resJson = await res.json();
				jwtToken = _.get(resJson, "AuthenticationResult.IdToken");

				// Next get the FedToken

				const resFedToken = await fetch(fedTokenEndpoint, {
					method: "POST",
					referrer: window.location.href.split("/?")[0],
					headers: {
						"Authorization" : jwtToken,
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({})
				});
				const creds = await resFedToken.json();
				window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(creds.body.accessKeyId, creds.body.secretAccessKey, creds.body.sessionToken);
			} catch (err) {
				console.error(err);
			}



		}, 1000 * 60 * REFRESH_INTERVAL_MINUTES);
	}
}

function cancelTokenRefreshInterval() { //eslint-disable-line
	if (intervalId) {
		window.clearInterval(intervalId);
	}
}

export function getJwtToken() {
	return jwtToken;
}

function receiveMessage(data) {
	console.log("GOT MESSAGE", data);
	try {
		const _data = JSON.parse(data.data);

		switch (_data.method) {
			case "tokenUpdated": {
				jwtToken = _data.token.jwt;
				break;
			}
			case "security-context-initialized": {
				// initializeConfirmed = true;
				break;
			}
			case "setAwsTempCredentials": {
				console.log("Setting new temp credentials", _data.creds);
				window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(_data.creds.accessKeyId, _data.creds.secretAccessKey, _data.creds.sessionToken);
				break;
			}	
			default: {
				console.log("Ignoring message");
			}
		}

	} catch (e) {
		console.warn(e);
	}
}